import { MEAL_PLAN_CARD_COPY, type MealPlanCardState } from "@/lib/mealPlanChatCard";

/**
 * #1452 — the one button that saves the week from chat. Sits in the chat
 * column above the composer (flex-shrink-0, no fixed positioning: the
 * keyboard architecture in Index.tsx owns the column, and this is a child of
 * it). Renders nothing without a plan in play.
 */
export default function MealPlanCommitBar({
  state,
  committing,
  onCommit,
  onOpenPlan,
}: {
  state: MealPlanCardState | null;
  committing: boolean;
  onCommit: () => void;
  onOpenPlan: () => void;
}) {
  if (!state) return null;
  const done = state.committed;
  return (
    <div
      data-testid="meal-plan-commit-bar"
      className="font-body"
      style={{
        flexShrink: 0,
        margin: "0 12px 8px",
        background: "#FFFFFF",
        border: "1px solid #C8C8F4",
        borderRadius: 14,
        padding: "10px 12px",
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 10 }}>
        <span style={{ fontSize: 13.5, fontWeight: 600, color: "#1C1A3E" }}>🍽️ {MEAL_PLAN_CARD_COPY.title}</span>
        <button
          type="button"
          onClick={onOpenPlan}
          data-testid="meal-plan-commit-bar-open"
          style={{ background: "none", border: "none", padding: 0, cursor: "pointer", fontSize: 12.5, fontWeight: 600, color: "#5050C8" }}
        >
          {MEAL_PLAN_CARD_COPY.open} →
        </button>
      </div>
      <p style={{ fontSize: 12.5, color: "#54525C", lineHeight: 1.4, margin: 0 }} data-testid="meal-plan-commit-bar-line">
        {done ? MEAL_PLAN_CARD_COPY.savedLine : state.lastChange ? `Latest change · ${state.lastChange}` : MEAL_PLAN_CARD_COPY.subtitle}
      </p>
      <button
        type="button"
        onClick={onCommit}
        disabled={done || committing}
        data-testid="meal-plan-commit-bar-save"
        style={{
          width: "100%",
          background: done ? "#E8E8F4" : "#5050C8",
          color: done ? "#54525C" : "#FFFFFF",
          border: "none",
          borderRadius: 12,
          padding: "11px 14px",
          fontSize: 14,
          fontWeight: 600,
          cursor: done || committing ? "default" : "pointer",
        }}
      >
        {done ? MEAL_PLAN_CARD_COPY.saved : committing ? MEAL_PLAN_CARD_COPY.saving : MEAL_PLAN_CARD_COPY.save}
      </button>
    </div>
  );
}
